import v4 from './node_modules-uuid-dist-esm-browser-v4.js';

const util = {
  /**
   * Generate a UUID.
   */
  generateUUID() {
    return v4();
  },
  /**
   * Generates a full style formatted date and time (e.g. 01/01/2024, 10:00:00 AM).
   */
  formatDateTime(timestamp) {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(timestamp);
  },
  getFormattedDate(timestamp) {
    const formattedDateTime = this.formatDateTime(timestamp);
    return formattedDateTime.split(",")[0].trim();
  },
  getFormattedTime(timestamp) {
    const formattedDateTime = this.formatDateTime(timestamp);
    return formattedDateTime.split(",")[1].trim();
  },
  /**
   * Creates deep copy of conversationEntries for searching.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createDeepCopy(conversationEntries) {
    return JSON.parse(JSON.stringify(conversationEntries));
  }
};
const getFormattedTime = (timeStamp) => {
  return new Date(timeStamp).toLocaleTimeString("en-us", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  });
};
const formatDateWithOrdinal = (date) => {
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };
  return `${getOrdinal(day)} ${month} ${year}`;
};

export { formatDateWithOrdinal, getFormattedTime, util };
//# sourceMappingURL=src-utils-miaw-common.js.map
